import Vue from 'vue'

Vue.directive('scroll-to-error', {
  bind(el) {
    el.addEventListener('submit', async (event) => {
      event.preventDefault()
      // wait for the nextTick because the error class is not visible in DOM yet
      await Vue.nextTick()
      const errorElements = document.getElementsByClassName('error--text')
      if(errorElements && errorElements.length > 0){
        errorElements[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
      }
    })
  },
  unbind(el){
    el.removeEventListener('submit', null)
  },
})

Vue.directive('click-outside', {
  bind(el, binding) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        if (typeof binding.value === 'function') {
          binding.value(event)
        }
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
})
